import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import enTranslation from './locales/en/translation.json';
import esTranslation from './locales/es/translation.json';
import ptTranslation from './locales/pt/translation.json';

i18n
  .use(LanguageDetector) // Detects the browser language
  .use(initReactI18next) // Passes i18n instance to react-i18next
  .init({
    resources: {
      en: {
        translation: enTranslation
      },
      es: {
        translation: esTranslation
      },
      pt: {
        translation: ptTranslation
      }
    },
    fallbackLng: 'en', // Default language if detection fails
    detection: {
      order: ['navigator', 'localStorage', 'cookie'], // Detect from browser, localStorage, or cookie
      caches: ['localStorage', 'cookie']
    },
    interpolation: {
      escapeValue: false // React already escapes by default
    }
  });

export default i18n;
